import { REACT_APP_MAIN_SOCKET_API_URL } from '../../config/runtimeEnv'

// Use server origin only (e.g. https://demo-api.worldsafesystem.com). Socket.io client uses path /socket.io by default.
// If you see "Invalid namespace", the server may be sending namespaced packets; use the same origin and ensure server uses default namespace.
export const MAIN_SOCKET_API_CONFIG = {
  URL: REACT_APP_MAIN_SOCKET_API_URL
}

export const MAIN_SOCKET_API_EVENTS = {
  // request/response style events
  LIST_MESSAGES: 'message:list',
  LIST_MESSAGES_RESULT: 'message:list::response',
  CREATE_MESSAGE: 'messages::create',
  CREATE_MESSAGE_RESULT: 'messages::create::response',
  // delivery/read receipts (client -> server)
  MARK_MESSAGES_RECEIVED: 'messages::received',
  MARK_MESSAGES_READ: 'messages::read',
  // server push events
  MESSAGE_CREATED: 'message:created',
  MESSAGES_CREATED: 'messages created',
  // delivery/read receipts (server -> client)
  MESSAGES_RECEIVED: 'messages received',
  MESSAGES_READ: 'messages read',
  // room subscriptions
  JOIN: 'chat:join',
  LEAVE: 'chat:leave',

  // --- Chat groups (real-time, no REST) ---
  /** Canonical list event (same as Android/iOS); response via Socket.IO ack. */
  LIST_CHAT_GROUPS: 'chatGroups::get',
  CHAT_GROUP_MESSAGES_GET: 'chatGroupMessages::get',
  CHAT_GROUP_MESSAGES_GET_RESULT: 'chatGroupMessages::get::response',
  CHAT_GROUP_MESSAGES_CREATE: 'chatGroupMessages::create',
  CHAT_GROUP_MESSAGES_SUBSCRIBE: 'chatGroupMessages::subscribe',
  CHAT_GROUP_MESSAGES_UNSUBSCRIBE: 'chatGroupMessages::unsubscribe',
  CHAT_GROUP_MESSAGE_CREATED: 'chatGroupMessage created',
  /** Per-member read receipts for an open chat group (server → client). */
  CHAT_GROUP_MESSAGES_READ: 'chatGroupMessages read',
  /** Chat group removed or user lost membership (server → client). */
  CHAT_GROUP_DELETED: 'chatGroup deleted',
  /** Chat group metadata changed for current members (server → client). */
  CHAT_GROUP_UPDATED: 'chatGroup updated',
  /** User was added to a new chat group (server → client). */
  CHAT_GROUP_CREATED: 'chatGroup created',
  /** Mark all unread group messages read for the current user (client → server). */
  MARK_CHAT_GROUP_MESSAGES_READ: 'message::read',
  CREATE_CHAT_GROUP: 'chatGroup::create',
  CREATE_CHAT_GROUP_RESULT: 'chatGroup::create::response',
  UPDATE_CHAT_GROUP: 'chatGroup::update',
  UPDATE_CHAT_GROUP_RESULT: 'chatGroup::update::response',
  DELETE_CHAT_GROUP: 'chatGroup::delete',
  DELETE_CHAT_GROUP_RESULT: 'chatGroup::delete::response',

  /** Legacy push subscription management (Web Push background notifications). */
  USERS_ADD_BROWSER_ENDPOINT: 'users::add_browser_endpoint',
  USERS_REMOVE_BROWSER_ENDPOINT: 'users::remove_browser_endpoint',

  // --- Map real-time (see docs/socket/MAP_SOCKET_CONTRACT.md) ---
  // room subscriptions
  MAP_JOIN: 'map:join',
  MAP_LEAVE: 'map:leave',
  // optional: request/response for initial map data over socket
  MAP_LIST: 'map:list',
  MAP_LIST_RESULT: 'map:list:result',
  // server push events (backend must emit these when map data changes)
  MAP_DEVICE_POSITION_UPDATED: 'map:device:position',
  MAP_DEVICE_UPDATED: 'map:device:updated',
  MAP_DEVICE_REMOVED: 'map:device:removed',
  MAP_TRACKING_GROUP_UPDATED: 'map:trackingGroup:updated',
  MAP_TRACKING_GROUP_REMOVED: 'map:trackingGroup:removed',
  MAP_REGION_UPDATED: 'map:region:updated',
  MAP_REGION_REMOVED: 'map:region:removed',
  // Zone CRUD/activation: payload { zoneId }; the client refetches the zone via REST
  MAP_ZONE_UPDATED: 'map:zone:updated',
  MAP_ZONE_REMOVED: 'map:zone:removed',

  /** Legacy server push: device/tracker position (see useMapRealtime + coordinatesCreatedMessage) */
  COORDINATES_CREATED: 'coordinates created',

  /** Legacy server push: device/tracker row update (includes tracker telemetry on refresh) */
  DEVICE_MANAGER_UPDATED: 'device_manager updated',

  // --- Field operations / forms intake (prise de service) ---
  FORM_FILLED_CREATED: 'form_filled created',
  FORM_FILLED_UPDATED: 'form_filled updated'
}
